export const MESSAGE_ERROR = {
  DUPLICATE_NAME_CLIENT: 'name should be unique',
  DUPLICATE_NAME_BUDGET: 'name should be unique',
};
